import React from "react"
import { FormProvider, SubmitHandler, useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup';
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import { Button } from "react-bootstrap";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { useCompteChangeLoginEnvoiMailMutation, useLazyCompteLoginExistQuery } from "../../../redux/slice/api/FO/compteApi";
import { toast } from "react-toastify";
import { IEmail } from "../../../models/interfaces/IEmail";
import { EmailSchema } from "../../../models/schema/emailSchema";
//import keycloak from "../../../keycloak";
//import { resetCompte } from "../../../redux/slice/compte.slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useKeycloak } from "@react-keycloak/web";
import { resetCompte } from "../../../redux/slice/compte.slice";




const PageMonCompte: React.FC = () => {
  //const navigate = useNavigate();
  //const dispatch = useDispatch();
  const compte = useSelector((state: RootState) => state.compte);
  const [checkLoginExist] = useLazyCompteLoginExistQuery();
  const dispatch = useDispatch();
  const {keycloak} = useKeycloak();
  
  const handleToastClose = () => {
    dispatch(resetCompte());
    keycloak.logout();
  };

  const formMethodsEmail = useForm<IEmail>({
    defaultValues: {
      EmailActuel :  compte.Login,
      NouveauEmail: "",
      ConfirmationEmail: "",
    }, 
    mode: "all",
    reValidateMode: "onBlur",
    resolver: yupResolver(EmailSchema),
});

  const [
    updateEmail,
    ] = useCompteChangeLoginEnvoiMailMutation();
  
  // setValue, setError, clearErrors,getValues
  const { handleSubmit:handleSubmitEmail ,setError} =
  formMethodsEmail;

  

const onSubmitEmail: SubmitHandler<any> = async (data) => {
  if (compte.Login?.toLowerCase() === data.EmailActuel.toLowerCase()) {
    const payload = await checkLoginExist({ 
      Login: data.NouveauEmail,
      IdCompte: compte.Id 
    }).unwrap();
      if (payload.Exist) {
        setError("NouveauEmail", { type: "required", message: "Le nouvel email renseigné est déjà associé à un compte pour le site ''. Merci de contacter le support." }, { shouldFocus: true })
      } else {
        const EnvoiMail = await updateEmail({Login: data.EmailActuel, NewLogin: data.NouveauEmail }).unwrap();
        if (EnvoiMail.ChangementValide) {
          toast.success("Nouvel email pris en compte. Merci de consulter votre messagerie pour terminer la mise à jour.", {
            onClose: handleToastClose,
          }
        );

          
        } else {
          toast.error("Erreur lors de la modification de l'Email")
        }
      }
    
  } else {
     setError("EmailActuel", { type: "required", message: "Le mail rensigné n'est pas correcte" }, { shouldFocus: true });
  }

  };

  const onErrorEmail = (errors: any) => {

  };

return (
    <>
      <div className="container text-center">
        <div className="row pt-3 pb-5">
          <div className="col col-6 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person-circle pe-2" />Modification e-mail</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-6 offset-md-3 col-6 ">
          <FormProvider {...formMethodsEmail}>
            <form onSubmit={handleSubmitEmail((data) => onSubmitEmail(data),onErrorEmail)}>
              <CpntForm>
                <CpntFormSection pSectionLabel="Modification e-mail">
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                      <TextInput
                          label="E-mail actuel"
                          formName="EmailActuel"
                          validationStyle={validationMode.classic}
                          placeholder="Email@exemple.com"
                          disabled
                        />
                        </CpntFormSectionContainer>
                        <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                        <TextInput
                          label="Nouvel e-mail"
                          formName="NouveauEmail"
                          validationStyle={validationMode.classic}
                          placeholder="Email@exemple.com"
                        />
                        </CpntFormSectionContainer>
                        <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                        <TextInput
                          label="Confirmation du nouvel e-mail"
                          formName="ConfirmationEmail"
                          validationStyle={validationMode.classic}
                          placeholder="Email@exemple.com"
                        />
                        </CpntFormSectionContainer>
                        <div></div>
                      <CpntFormSectionNavigation>
                        {/* <div></div> */}
                        <Button type="submit" className="col-4 btn-secondary">
                          Enregistrer
                        </Button>
                        {/* <div></div> */}
                      </CpntFormSectionNavigation>

                </CpntFormSection>
              </CpntForm>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
    <div>
  <p>
    <b style={{ color: 'red' }}>
      Une fois votre modification effectuée, vous serez redirigé vers la page de connexion.<br/> Un message de validation contenant un lien d&apos;activation vous sera envoyé sur votre nouvelle adresse électronique.
    </b>
  </p>
</div>
    </>
  );
};

export default PageMonCompte;


